import { groupBy } from 'lodash';

export const getTableItems = (data = []) => {
  const serviceGroups = groupBy(data, 'parentService');

  return Object.entries(serviceGroups).map(([serviceName, requests]) => {
    const regionCountMap = {};
    requests.forEach((req) => {
      const region = req.regionName || 'Без района';
      regionCountMap[region] = (regionCountMap[region] || 0) + 1;
    });

    const parentItem = {
      key: `service_${serviceName}`,
      service: serviceName,
      quantity: Object.values(regionCountMap).reduce(
        (sum, val) => sum + val,
        0
      ),
      children: [],
    };

    Object.entries(regionCountMap).forEach(([region, count]) => {
      parentItem[region] = count;
    });

    const parentServiceGroups = groupBy(requests, 'service');
    parentItem.children = Object.entries(parentServiceGroups).map(
      ([pSvc, subRequests]) => {
        const subRegionCountMap = {};
        subRequests.forEach((r) => {
          const region = r.regionName || 'Без района';
          subRegionCountMap[region] = (subRegionCountMap[region] || 0) + 1;
        });

        const childItem = {
          key: `child_${serviceName}_${pSvc}`,
          service: pSvc,
          quantity: Object.values(subRegionCountMap).reduce(
            (sum, val) => sum + val,
            0
          ),
        };

        Object.entries(subRegionCountMap).forEach(([region, count]) => {
          childItem[region] = count;
        });

        return childItem;
      }
    );

    return parentItem;
  });
};
